import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import useCountdownTimer from 'app/components/CountdownTimer/useCountdownTimer';
import { countBox, infoTextTimer, timer, resent } from './CoundownTimer.sx';
import logger from 'app/utils/logger';

interface Props {
  otp?: boolean;
  link?: boolean;
  text?: string;
  repeat: () => void;
  timerTime?: any;
  errorCase?: boolean;
}

const CountdownTimer = (props: Props) => {
  const { otp, link, repeat, timerTime, text, errorCase } = props;
  const { t, minutes, remainingSeconds, seconds, setSeconds } = useCountdownTimer({ link, timerTime, errorCase });

  logger.log(seconds);

  return (
    <>
      {seconds > 0 && (
        <Box sx={countBox}>
          <Typography sx={infoTextTimer}>
            {text ? text : otp ? t('otp.resentOtp') : link ? t('recovery.linkResend') : t('confirm.timer')}:
          </Typography>
          <Typography sx={timer}>
            {minutes}:{remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds}
          </Typography>
        </Box>
      )}
      {seconds === 0 && (
        <Button
          variant={'text'}
          sx={link ? { ...resent, mt: '0' } : resent}
          onClick={() => {
            setSeconds(timerTime);
            // link ? 60 : 120
            repeat();
          }}
        >
          {otp ? t('otp.resentOtp') : link ? t('recovery.linkResend') : t('confirm.resent')}
        </Button>
      )}
    </>
  );
};

export default CountdownTimer;
